import Crud from './crud'
import { request_detail, request_list, update_detail, create_detail, remove_detail } from '@/commons/hpod';
import { sendSuccessNotice, sendErrorNotice, refreshResource } from '@/commons/utils';
import Vue from 'vue';
import configs from '@/configs';

var crud = new Crud('cn-orders', 'đơn hàng CN');

const state = {
    ...crud.state,
    selected: {},
    products: [],
    waybills: [],
    fees: [],
    collections: [],
};
const getters = {
    ...crud.getters,
    transportFees: state => (state.fees || []).filter(f => f.FeeGroup === 'TRANSPORT'),
    trustFees: state => (state.fees || []).filter(f => f.FeeGroup === 'TRUST'),
    serviceFees: state => (state.fees || []).filter(f => f.FeeGroup === 'SERVICE'),
    taxFees: state => (state.fees || []).filter(f => f.FeeGroup === 'TAX'),
};
const actions = {
    ...crud.actions,
    // Load full detail with sub-resources
    getFullDetail({ commit }, id) {
        return new Promise((resolve) => {
            commit("setLoading", { loading: true });
            request_detail('cn-orders', data => {
                if (data && data.data) {
                    commit('setDetail', data.data);
                    commit('setProducts', data.data.products || []);
                    commit('setWaybills', data.data.waybills || []);
                    commit('setFees', data.data.fees || []);
                    commit('setCollections', data.data.collections || []);
                }
                commit("setLoading", { loading: false });
                resolve(data);
            }, Vue.http, id, this.state.authentication.token);
        });
    },
    markCustomsReady({ dispatch }, orderId) {
        return new Promise((resolve, reject) => {
            const token = this.state.authentication.token;
            const req = {
                headers: {
                    "Authorization": `Bearer ${token}`,
                    "Content-Type": "application/json",
                }
            };
            Vue.http.post(`${configs.API}/api/cn-orders/${orderId}/mark-customs-ready/`, {}, req).then(res => {
                sendSuccessNotice('Đơn hàng đã được chuyển sang Chờ thông quan.');
                dispatch('getFullDetail', orderId);
                refreshResource();
                resolve(res.data);
            }, error => {
                const reason = error && error.body && error.body.reason ? error.body.reason : 'Không thể chuyển trạng thái đơn hàng.';
                sendErrorNotice(reason);
                reject(error);
            });
        });
    },
    // ===== Products =====
    addProduct({ commit, dispatch }, { orderId, data }) {
        return new Promise((resolve, reject) => {
            const token = this.state.authentication.token;
            const req = {
                headers: {
                    "Authorization": `Bearer ${token}`,
                    "Content-Type": "application/json",
                }
            };
            Vue.http.put(`${configs.API}/api/cn-orders/${orderId}/products/`, data, req).then(res => {
                sendSuccessNotice('Thêm hàng hóa thành công.');
                dispatch('getFullDetail', orderId);
                resolve(res.data);
            }, error => {
                const reason = error && error.body && error.body.reason ? error.body.reason : 'Không thể thêm hàng hóa.';
                sendErrorNotice(reason);
                reject(error);
            });
        });
    },
    editProduct({ dispatch }, { orderId, productId, data }) {
        return new Promise((resolve, reject) => {
            const token = this.state.authentication.token;
            const req = {
                headers: {
                    "Authorization": `Bearer ${token}`,
                    "Content-Type": "application/json",
                }
            };
            Vue.http.post(`${configs.API}/api/cn-orders/${orderId}/products/${productId}`, data, req).then(res => {
                sendSuccessNotice('Cập nhật hàng hóa thành công.');
                dispatch('getFullDetail', orderId);
                resolve(res.data);
            }, error => {
                const reason = error && error.body && error.body.reason ? error.body.reason : 'Không thể cập nhật hàng hóa.';
                sendErrorNotice(reason);
                reject(error);
            });
        });
    },
    removeProduct({ dispatch }, { orderId, productId }) {
        return new Promise((resolve, reject) => {
            const token = this.state.authentication.token;
            const req = {
                headers: {
                    "Authorization": `Bearer ${token}`,
                }
            };
            Vue.http.delete(`${configs.API}/api/cn-orders/${orderId}/products/${productId}`, req).then(res => {
                sendSuccessNotice('Đã xóa hàng hóa.');
                dispatch('getFullDetail', orderId);
                resolve(res.data);
            }, error => {
                const reason = error && error.body && error.body.reason ? error.body.reason : 'Không thể xóa hàng hóa.';
                sendErrorNotice(reason);
                reject(error);
            });
        });
    },
    // ===== Waybills =====
    addWaybill({ dispatch }, { orderId, data }) {
        return new Promise((resolve) => {
            const token = this.state.authentication.token;
            const req = {
                headers: {
                    "Authorization": `Bearer ${token}`,
                    "Content-Type": "application/json",
                }
            };
            Vue.http.put(`${configs.API}/api/cn-orders/${orderId}/waybills/`, data, req).then(res => {
                sendSuccessNotice('Thêm vận đơn thành công.');
                dispatch('getFullDetail', orderId);
                resolve(res.data);
            }, () => {
                sendErrorNotice('Không thể thêm vận đơn.');
            });
        });
    },
    editWaybill({ dispatch }, { orderId, waybillId, data }) {
        return new Promise((resolve) => {
            const token = this.state.authentication.token;
            const req = {
                headers: {
                    "Authorization": `Bearer ${token}`,
                    "Content-Type": "application/json",
                }
            };
            Vue.http.post(`${configs.API}/api/cn-orders/${orderId}/waybills/${waybillId}`, data, req).then(res => {
                sendSuccessNotice('Cập nhật vận đơn thành công.');
                dispatch('getFullDetail', orderId);
                resolve(res.data);
            }, () => {
                sendErrorNotice('Không thể cập nhật vận đơn.');
            });
        });
    },
    removeWaybill({ dispatch }, { orderId, waybillId }) {
        return new Promise((resolve) => {
            const token = this.state.authentication.token;
            const req = {
                headers: {
                    "Authorization": `Bearer ${token}`,
                }
            };
            Vue.http.delete(`${configs.API}/api/cn-orders/${orderId}/waybills/${waybillId}`, req).then(res => {
                sendSuccessNotice('Đã xóa vận đơn.');
                dispatch('getFullDetail', orderId);
                resolve(res.data);
            }, () => {
                sendErrorNotice('Không thể xóa vận đơn.');
            });
        });
    },
    // ===== Fees =====
    addFee({ dispatch }, { orderId, data }) {
        return new Promise((resolve) => {
            const token = this.state.authentication.token;
            const req = {
                headers: {
                    "Authorization": `Bearer ${token}`,
                    "Content-Type": "application/json",
                }
            };
            Vue.http.put(`${configs.API}/api/cn-orders/${orderId}/fees/`, data, req).then(res => {
                sendSuccessNotice('Thêm phí thành công.');
                dispatch('getFullDetail', orderId);
                resolve(res.data);
            }, () => {
                sendErrorNotice('Không thể thêm phí.');
            });
        });
    },
    editFee({ dispatch }, { orderId, feeId, data }) {
        return new Promise((resolve) => {
            const token = this.state.authentication.token;
            const req = {
                headers: {
                    "Authorization": `Bearer ${token}`,
                    "Content-Type": "application/json",
                }
            };
            Vue.http.post(`${configs.API}/api/cn-orders/${orderId}/fees/${feeId}`, data, req).then(res => {
                sendSuccessNotice('Cập nhật phí thành công.');
                dispatch('getFullDetail', orderId);
                resolve(res.data);
            }, () => {
                sendErrorNotice('Không thể cập nhật phí.');
            });
        });
    },
    removeFee({ dispatch }, { orderId, feeId }) {
        return new Promise((resolve) => {
            const token = this.state.authentication.token;
            const req = {
                headers: {
                    "Authorization": `Bearer ${token}`,
                }
            };
            Vue.http.delete(`${configs.API}/api/cn-orders/${orderId}/fees/${feeId}`, req).then(res => {
                sendSuccessNotice('Đã xóa phí.');
                dispatch('getFullDetail', orderId);
                resolve(res.data);
            }, () => {
                sendErrorNotice('Không thể xóa phí.');
            });
        });
    },
    exportProducts({ state }) {
        const token = this.state.authentication.token;
        const id = state.selected.ID;
        if (!id) return;
        window.open(`${configs.API}/api/cn-orders/${id}/export-products/?token=${token}`, '_blank');
    },
    // ===== Collections =====
    addCollection({ dispatch }, { orderId, data }) {
        return new Promise((resolve) => {
            const token = this.state.authentication.token;
            const req = {
                headers: {
                    "Authorization": `Bearer ${token}`,
                    "Content-Type": "application/json",
                }
            };
            Vue.http.put(`${configs.API}/api/cn-orders/${orderId}/collections/`, data, req).then(res => {
                sendSuccessNotice('Thêm khoản thu thành công.');
                dispatch('getFullDetail', orderId);
                resolve(res.data);
            }, error => {
                const reason = error && error.body && error.body.reason ? error.body.reason : 'Không thể thêm khoản thu.';
                sendErrorNotice(reason);
            });
        });
    },
    editCollection({ dispatch }, { orderId, collectionId, data }) {
        return new Promise((resolve) => {
            const token = this.state.authentication.token;
            const req = {
                headers: {
                    "Authorization": `Bearer ${token}`,
                    "Content-Type": "application/json",
                }
            };
            Vue.http.post(`${configs.API}/api/cn-orders/${orderId}/collections/${collectionId}`, data, req).then(res => {
                sendSuccessNotice('Cập nhật khoản thu thành công.');
                dispatch('getFullDetail', orderId);
                resolve(res.data);
            }, error => {
                const reason = error && error.body && error.body.reason ? error.body.reason : 'Không thể cập nhật khoản thu.';
                sendErrorNotice(reason);
            });
        });
    },
    removeCollection({ dispatch }, { orderId, collectionId }) {
        return new Promise((resolve) => {
            const token = this.state.authentication.token;
            const req = {
                headers: {
                    "Authorization": `Bearer ${token}`,
                }
            };
            Vue.http.delete(`${configs.API}/api/cn-orders/${orderId}/collections/${collectionId}`, req).then(res => {
                sendSuccessNotice('Đã xóa khoản thu.');
                dispatch('getFullDetail', orderId);
                resolve(res.data);
            }, error => {
                const reason = error && error.body && error.body.reason ? error.body.reason : 'Không thể xóa khoản thu.';
                sendErrorNotice(reason);
            });
        });
    },
};

const mutations = {
    ...crud.mutations,
    setProducts(state, items) {
        state.products = items;
    },
    setWaybills(state, items) {
        state.waybills = items;
    },
    setFees(state, items) {
        state.fees = items;
    },
    setCollections(state, items) {
        state.collections = items;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
